import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  GhostArticles,
  ghost,
  LoadingSpinner,
} from "@minerva-analytics/pantheon";
import { Helmet } from "react-helmet";

import ComingSoon from "../../components/ComingSoon";
import { GHOST_API } from "../../ghost";
import { SITE_URL } from "../../constants";
import { ArticlesContainer } from "./Articles.styles";

const colors = {
  background: "white",
  featuredbg: "white",
  featuredblurb: "#454545",
  title: "#454545",
  published: "#454545",
  author: "#454545",
  readtime: "#454545",
  viewmore: "#454545",
};

const fonts = {
  title: "Inter, sans-serif",
  body: "Inter, sans-serif",
};

const Articles = () => {
  const articles = useSelector((state) => state.ghost.getArticlesStatus);
  const { getArticles } = ghost.hooks.useGhostActions(GHOST_API);

  const dispatchArticles = async () => {
    try {
      await getArticles();
    } catch (error) {
      console.log(error); //eslint-disable-line
    }
  };

  useEffect(() => {
    dispatchArticles();
  }, []);

  if (articles.loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <Helmet>
        <title>Best Literary Quotes | LitMuse</title>
        <meta
          name="og:title"
          property="og:title"
          content="Best Literary Quotes | LitMuse"
        />
        <meta
          name="og:description"
          property="og:description"
          content="Love literature? Check out all of our favorite literary quotes and the stories behind them right here!"
        />
        <meta
          name="description"
          property="description"
          content="Love literature? Check out all of our favorite literary quotes and the stories behind them right here!"
        />
      </Helmet>
      <ArticlesContainer>
        {articles.count > 0 ? (
          <GhostArticles
            domain={SITE_URL}
            ghostApi={GHOST_API}
            colors={colors}
            fonts={fonts}
          />
        ) : (
          <ComingSoon />
        )}
      </ArticlesContainer>
    </>
  );
};

export default Articles;
